import React from "react";
import { ImageComponent } from "../components/common/Image.component";
import { Company } from "./Company";
import { HTMLProps } from "../model/HTMLProps";

interface CompanyImageProps extends HTMLProps {
  company: Company;
}
export function CompanyImage(props: CompanyImageProps) {
  const { company, ...imageProps } = props;
  
  // Default constraint for lists if no size specified
  if (!imageProps.width && !imageProps.maxWidth && !imageProps.height) {
    imageProps.maxWidth = 50;
  }

  return (
    <>
      {company.dp && (
        <ImageComponent
          image={company.dp}
          {...imageProps}
          className={`rounded ${props.className}`}
        />
      )}
    </>
  );
}
